import { createAction } from 'typesafe-actions';
import { takeLatest, put } from 'redux-saga/effects';
import { BODY_FIELD_FOCUSED, CONS_FIELD_FOCUSED, PROS_FIELD_FOCUSED } from 'features/review-form';
import { EReviewsElementBlock } from './types';

const ACTION_NAME = 'GA:focus';

/**
 * Событие должно срабатывать единоразово при взаимодействии с блоком
 *
 * @see https://docs.google.com/document/d/14v6VhSpFLlEPekvGSRJh5klKkGJp6oPhplFlxorrAyM/edit#heading=h.6iyxi97hhg11
 */
export const writeReviewText = createAction(
  ACTION_NAME,
  ({ elementName }: { elementName: 'Общие впечатления' | 'Достоинства' | 'Недостатки' }) => ({
    elementType: 'input',
    elementBlock: EReviewsElementBlock.FORM,
    elementName,
    elementText: 'Отзыв',
  }),
)();

export function* runGaFocusDetector() {
  let bodyFieldFocusedReceived = false;
  yield takeLatest(BODY_FIELD_FOCUSED, function* putGaFocus() {
    if (!bodyFieldFocusedReceived) {
      bodyFieldFocusedReceived = true;
      yield put(writeReviewText({ elementName: 'Общие впечатления' }));
    }
  });

  let prosFieldFocusedReceived = false;
  yield takeLatest(PROS_FIELD_FOCUSED, function* putProsFieldFocused() {
    if (!prosFieldFocusedReceived) {
      prosFieldFocusedReceived = true;
      yield put(writeReviewText({ elementName: 'Достоинства' }));
    }
  });

  let consFieldFocusedReceived = false;
  yield takeLatest(CONS_FIELD_FOCUSED, function* putConsFieldFocused() {
    if (!consFieldFocusedReceived) {
      consFieldFocusedReceived = true;
      yield put(writeReviewText({ elementName: 'Недостатки' }));
    }
  });
}
